// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2cqld","log":"ModalInventoryLogs_log__3rld-","date":"ModalInventoryLogs_date__2aJBp","userName":"ModalInventoryLogs_userName__3eK26"};